/* One responsive MP4 request; muted loop autoplay with reduced-motion fallback. */
if (!customElements.get('bestek-journey-background')) {
  customElements.define('bestek-journey-background', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('video');
      if (!video) return;
      video.autoplay = true;
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const narrow = matchMedia('(max-width: 1066px)');
      const events = new AbortController();
      let inView = false;
      let failed = false;
      const selectSource = () => {
        const key = narrow.matches ? 'mobile' : 'desktop';
        video.poster = this.dataset[key + 'Poster'];
        const next = this.dataset[key + 'Src'];
        if (next && video.getAttribute('src') !== next) {
          this.removeAttribute('data-playing-frame');
          video.src = next;
          video.load();
        }
      };
      const sync = () => {
        if (reduced.matches) this.removeAttribute('data-playing-frame');
        if (!inView || document.hidden || reduced.matches || failed) {
          video.pause();
          return;
        }
        selectSource();
        video.muted = true;
        if (video.paused) video.play().catch(() => {});
      };
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.02 });
      observer.observe(this);
      video.addEventListener('canplay', sync, { signal: events.signal });
      video.addEventListener('playing', () => { this.setAttribute('data-playing-frame', ''); }, { signal: events.signal });
      video.addEventListener('error', () => {
        failed = true;
        this.removeAttribute('data-playing-frame');
        sync();
      }, { signal: events.signal });
      document.addEventListener('visibilitychange', sync, { signal: events.signal });
      const resize = () => { if (video.getAttribute('src')) selectSource(); sync(); };
      narrow.addEventListener('change', resize);
      reduced.addEventListener('change', sync);
      this.cleanup = () => {
        video.pause();
        observer.disconnect();
        events.abort();
        narrow.removeEventListener('change', resize);
        reduced.removeEventListener('change', sync);
        this.cleanup = null;
      };
      sync();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
